import {PasswordApiModel} from '../../api/models/password.api-model';
import {UserApiModel} from '../../api/models/user.api-model';
import {MediaObjectViewModel} from './media-object.view-model';
import {UserViewModel} from '../../features/user/settings/user.view-model';
import {FollowApiModel} from "../../api/models/follow.api-model";

export class CurrentUserViewModel extends UserViewModel {
  public id: number;
  public username: string;
  public email: string | null;
  public password: PasswordApiModel;
  public slug: string | null;
  public avatar: MediaObjectViewModel;
  public background: MediaObjectViewModel;
  public images: string[];
  public info: string;
  public roles: string[];
  public currentPassword: string;
  public savedMarketplaceAdvertisements: string[]|FollowApiModel[];

  public constructor(public apiModel: UserApiModel) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  fromApiModel(apiModel: UserApiModel): this {
    if (!apiModel) {
      return this;
    }
    this.apiModel = apiModel;
    this['@id'] = apiModel['@id'] ?? this['@id'];
    this.id = this.apiModel.id;
    this.username = this.apiModel.username;
    this.reputationRank = this.apiModel.reputationRank;
    this.email = this.apiModel.email;
    this.slug = this.apiModel.slug;
    this.deleted = !!this.apiModel.deleted;
    this.images = this.apiModel.images;
    this.info = this.apiModel.info as string;
    this.socialProfile = this.apiModel.socialProfile;
    this.settings = this.apiModel.settings;
    this.settings = this.apiModel.settings;
    this.roles = this.apiModel.roles;
    return this;
  }

  toApiModel(): UserApiModel {
    this.apiModel['@id'] = this.apiModel['@id'] || this['@id'];
    this.apiModel.id = this.id;
    this.apiModel.username = this.username;
    this.apiModel.email = this.email;
    this.apiModel.slug = this.slug;
    this.apiModel.deleted = this.deleted;
    this.apiModel.images = this.images;
    this.apiModel.info = this.info;
    this.apiModel.socialProfile = this.socialProfile;
    this.apiModel.settings = this.settings;
    return this.apiModel;
  }
}
